import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { FaqData } from "../types";

export const getFaqsListByFaqGroup = async (
  faqGroupId: string,
): Promise<FaqData[]> => {
  try {
    const collectionRef = collection(db, `faqGroups/${faqGroupId}/faqs`);
    const q = query(collectionRef, orderBy("order", "asc"));

    const faqsSnapshot = await getDocs(q);

    return faqsSnapshot.docs.map(
      (doc) => ({ ...doc.data(), id: doc.id }) as FaqData,
    );
  } catch (error) {
    console.error("Failed to fetch faqs list:", error);
    throw error;
  }
};
